import { constructLink } from "@/utils/linkConstructor";
import NearYouCard from "./NearYouCard";

type Props = {
  airports: any;
  currentAirport: string;
  locationName: string;
  heading?: string;
  subheading?: string;
};

const AirportsNearYou = ({
  airports,
  currentAirport,
  locationName,
  heading,
  subheading,
}: Props) => {
  const removePresentAirport = (airports: any) => {
    const airportList = airports.filter((airport: any) => {
      return airport.kayakId !== currentAirport;
    });
    return airportList;
  };

  const cleanedAirports = removePresentAirport(airports);

  return (
    <div className="mt-5 lg:mt-[60px] bg-white px-[13px] py-[30px]">
      <div className="mx-auto max-w-7xl">
        <div className="flex justify-between w-full">
          <div className="space-y-[6px] lg:space-y-[10px] mb-[18px]">
            <h2 className="text-base font-extrabold lg:text-3xl text-my-dark-blue">
              {heading ? heading : `Nearby Aiports to ${locationName}`}
            </h2>
            <p className="text-sm font-normal text-my-light-blue lg:font-light lg:text-base">
              {subheading
                ? subheading
                : `There are a few more airports in the vicinity of ${locationName} that might have a better car rental deal that suits you better. Find them below.`}
            </p>
          </div>
        </div>
        {cleanedAirports.length === 0 ? (
          <div className="p-10 text-center opacity-50 select-none">{`No airports found :(`}</div>
        ) : (
          <div className="grid gap-[16px] lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-3">
            {cleanedAirports.map((airport: any) => (
              <NearYouCard
                key={airport.kayakId}
                id={airport.kayakId}
                name={airport.entityKey}
                startingPrice="$20"
                link={constructLink(airport)}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default AirportsNearYou;
